import React from 'react';

interface Props {
  monthlyPrice: number;
  annualPrice: number;
  setMonthlyPrice: (v: number) => void;
  setAnnualPrice: (v: number) => void;
}

const PricingSection: React.FC<Props> = ({ monthlyPrice, annualPrice, setMonthlyPrice, setAnnualPrice }) => {
  return (
    <div className="section-block">
      <h3>Preços Padrão</h3>
      <div className="pricing-fields">
        <label>
          Mensal (R$):
          <input type="number" step="0.01" value={monthlyPrice} onChange={e => setMonthlyPrice(Number(e.target.value))} />
        </label>
        <label>
          Anual (R$):
          <input type="number" step="0.01" value={annualPrice} onChange={e => setAnnualPrice(Number(e.target.value))} />
        </label>
      </div>
      <p className="muted">As alterações são salvas automaticamente.</p>
    </div>
  );
};

export default PricingSection;
